import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Maladtopunecab() {



  const cardData = {


  keyword: "Malad to Pune Cab",

  headingDescription: "Trustline Cab provides reliable Malad to Pune cab services with safe, comfortable, and affordable transportation for business travel, corporate meetings, airport transfers, family trips, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our professional chauffeurs ensure timely pickup, smooth travel via the Mumbai-Pune Expressway, and a hassle-free journey from Malad to Pune. Our fleet includes AC Sedans, SUVs, Ertiga, Innova Crysta, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, experienced drivers, well-maintained vehicles, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Malad to Pune taxi services.",

  topPlaces: [
    {
      title: "Hinjewadi",
      description: "Hinjewadi is Pune's leading IT and business destination, home to Rajiv Gandhi Infotech Park, multinational companies, software firms, and corporate offices. It is a preferred destination for professionals traveling to Pune."
    },
    {
      title: "Pune Airport",
      description: "Pune Airport is an important travel hub connecting Pune with major cities across India. It is a popular destination for passengers requiring airport transfers and comfortable cab services."
    },
    {
      title: "Kharadi",
      description: "Kharadi is a major IT and commercial area in Pune, featuring EON IT Park, corporate offices, hotels, and business centers. It is one of the most preferred locations for business travelers."
    },
    {
      title: "Pimpri Chinchwad",
      description: "Pimpri Chinchwad is a major industrial and residential region near Pune, known for automobile companies, manufacturing units, engineering industries, and commercial developments."
    },
    {
      title: "Magarpatta City",
      description: "Magarpatta City is a modern integrated township featuring IT parks, corporate offices, shopping destinations, and residential communities. It is a popular destination for corporate and family travel."
    },
    {
      title: "Wakad",
      description: "Wakad is a rapidly growing Pune suburb known for residential projects, commercial complexes, restaurants, and excellent connectivity to Hinjewadi and other major areas."
    },
    {
      title: "Lonavala",
      description: "Lonavala is a scenic hill station near Pune famous for waterfalls, caves, viewpoints, and lush green valleys. It is a popular weekend destination for travelers from Mumbai."
    },
    {
      title: "Mahabaleshwar",
      description: "Mahabaleshwar is a famous hill station near Pune known for strawberry farms, viewpoints, lakes, and waterfalls. It is a popular outstation destination for family trips."
    },
    {
      title: "Lavasa",
      description: "Lavasa is a beautiful planned hill city near Pune offering lakeside views, adventure activities, scenic roads, and peaceful surroundings."
    },
    {
      title: "Pawna Lake",
      description: "Pawna Lake is a popular tourist destination near Pune known for camping, boating, mountain views, and relaxing nature experiences."
    }
  ],





"services": [
  {
    "name": "Malad to Pune Cab",
    "description": "Book Malad to Pune Cab for safe and comfortable intercity travel with professional chauffeurs, clean AC vehicles, fixed fares, doorstep pickup, luggage assistance, and reliable one way or round trip travel options."
  },
  {
    "name": "Malad to Pune Cab Service",
    "description": "Choose Malad to Pune Cab Service with Sedan, Ertiga, Innova, and SUV vehicles, experienced drivers, transparent pricing, online booking, and 24x7 customer support for hassle-free journeys."
  },
  {
    "name": "Malad to Pune Taxi",
    "description": "Travel with Malad to Pune Taxi offering affordable fares, comfortable AC cars, professional drivers, flexible pickup timings, and smooth highway transportation for business, family, and personal trips."
  },
  {
    "name": "Malad to Pune Taxi Service",
    "description": "Book Malad to Pune Taxi Service for reliable outstation travel with well-maintained vehicles, experienced chauffeurs, transparent pricing, doorstep pickup, and comfortable long-distance journeys."
  },
  {
    "name": "Malad to Pune One Way Cab",
    "description": "Reserve Malad to Pune One Way Cab for direct destination travel with fixed pricing, clean AC cars, professional drivers, and convenient doorstep pickup and drop service."
  },
  {
    "name": "Malad to Pune One Way Taxi",
    "description": "Choose Malad to Pune One Way Taxi for affordable single-trip travel with comfortable seating, luggage support, experienced chauffeurs, and reliable highway rides."
  },
  {
    "name": "Malad to Pune Cab Booking",
    "description": "Complete Malad to Pune Cab Booking online with instant confirmation, multiple vehicle options, secure reservations, and professional chauffeur-driven transportation."
  },
  {
    "name": "Malad to Pune Taxi Booking Online",
    "description": "Book Malad to Pune Taxi Booking Online with quick confirmation, transparent fares, flexible pickup schedules, and comfortable AC vehicles."
  },
  {
    "name": "Cab from Malad to Pune",
    "description": "Hire Cab from Malad to Pune for safe and convenient travel with Sedan, Ertiga, Innova Crysta, and SUV vehicles driven by experienced chauffeurs."
  },
  {
    "name": "Malad to Pune Car Rental",
    "description": "Reserve Malad to Pune Car Rental for private travel with premium vehicles, flexible booking options, affordable pricing, and comfortable outstation journeys."
  },
  {
    "name": "Malad to Pune Cab Fare",
    "description": "Check Malad to Pune Cab Fare with transparent rates, affordable packages, multiple vehicle choices, and no hidden charges for reliable travel."
  },
  {
    "name": "Malad to Pune Taxi Charges",
    "description": "Find Malad to Pune Taxi Charges with fixed pricing, budget-friendly packages, AC vehicles, and dependable cab services for every travel requirement."
  },
  {
    "name": "Cheap Cab Malad to Pune",
    "description": "Choose Cheap Cab Malad to Pune for economical travel with clean vehicles, professional drivers, affordable fares, and comfortable outstation transportation."
  },
  {
    "name": "Best Cab Service Malad to Pune",
    "description": "Book Best Cab Service Malad to Pune with premium vehicles, experienced chauffeurs, transparent pricing, timely pickup, and reliable customer support."
  },
  {
    "name": "Malad to Pune Outstation Cab",
    "description": "Reserve Malad to Pune Outstation Cab for safe long-distance travel with AC vehicles, fixed fares, professional drivers, and smooth highway journeys."
  },
  {
    "name": "Malad to Pune AC Taxi Service",
    "description": "Travel comfortably with Malad to Pune AC Taxi Service featuring sanitized air-conditioned cars, skilled chauffeurs, affordable pricing, and reliable service."
  },
  {
    "name": "Malad to Pune Innova Cab",
    "description": "Book Malad to Pune Innova Cab for family trips, corporate travel, airport transfers, and group journeys with spacious seating and premium comfort."
  },
  {
    "name": "Malad to Pune Ertiga Cab",
    "description": "Choose Malad to Pune Ertiga Cab for spacious six-seater travel with comfortable interiors, professional drivers, luggage space, and affordable fares."
  },
  {
    "name": "Malad to Pune SUV Taxi",
    "description": "Hire Malad to Pune SUV Taxi for luxury and comfortable travel with spacious vehicles, experienced chauffeurs, and reliable outstation transportation."
  },
  {
    "name": "Malad to Pune Cab Price",
    "description": "Check Malad to Pune Cab Price with transparent packages, affordable rates, multiple vehicle options, and easy online booking facilities."
  }
],

"tableData": [
  ["Malad to Pune Cab", "Malad to Pune Cab Service"],
  ["Malad to Pune Taxi", "Malad to Pune Taxi Service"],
  ["Malad to Pune One Way Cab", "Malad to Pune One Way Taxi"],
  ["Malad to Pune Cab Booking", "Malad to Pune Taxi Booking Online"],
  ["Cab from Malad to Pune", "Malad to Pune Car Rental"],
  ["Malad to Pune Cab Fare", "Malad to Pune Taxi Charges"],
  ["Cheap Cab Malad to Pune", "Best Cab Service Malad to Pune"],
  ["Malad to Pune Outstation Cab", "Malad to Pune AC Taxi Service"],
  ["Malad to Pune Innova Cab", "Malad to Pune Ertiga Cab"],
  ["Malad to Pune SUV Taxi", "Malad to Pune Cab Price"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Malad to Pune Cab Service",
    WhyChoosedescription: "Trustline Cab provides comfortable Malad to Pune cab services with professional drivers, well-maintained vehicles, and convenient travel solutions for smooth intercity journeys."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Malad",
    WhyChoosedescription: "Get easy pickup from Malad East, Malad West, railway station, hotels, offices, and residential areas with direct drop anywhere in Pune."
  },
  {
    WhyChooseheading: "Safe & Comfortable Mumbai Pune Travel",
    WhyChoosedescription: "Our experienced chauffeurs ensure a secure and relaxing journey with excellent knowledge of Mumbai–Pune Expressway and highway routes."
  },
  {
    WhyChooseheading: "Multiple Cab Options Available",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on passenger count, comfort, and luggage needs."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "Enjoy competitive Malad to Pune cab fares with clear pricing details before booking and no hidden charges."
  },
  {
    WhyChooseheading: "One Way & Round Trip Facilities",
    WhyChoosedescription: "Book one-way cabs, return trips, airport transfers, or customized travel packages according to your preferred schedule."
  },
  {
    WhyChooseheading: "Perfect for Corporate & Family Trips",
    WhyChoosedescription: "Our Malad to Pune cabs are suitable for business meetings, office travel, family vacations, airport transfers, and personal journeys."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Reserve your Malad to Pune cab anytime with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Malad to Pune Cab Service?",
    answer: "Yes, Trustline Cab offers reliable Malad to Pune cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Malad to Pune?",
    answer: "Yes, one-way cab services are available with convenient pickup from Malad and direct drop anywhere in Pune."
  },
  {
    question: "Do you provide pickup from Malad Railway Station?",
    answer: "Yes, pickup is available from Malad Railway Station, Malad East, Malad West, hotels, offices, and residential locations."
  },
  {
    question: "Which vehicles are available for Malad to Pune travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable long-distance travel."
  },
  {
    question: "Is Malad to Pune cab service available 24 hours?",
    answer: "Yes, our cab services operate 24/7 according to your preferred travel timing."
  },
  {
    question: "Can I book a return cab from Pune to Malad?",
    answer: "Yes, round-trip cab services are available for passengers planning return travel between Pune and Malad."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless included in the confirmed booking quotation."
  },
  {
    question: "Should I book my Malad to Pune cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and preferred pickup timing."
  },
  {
    question: "Do you provide Malad to Pune cabs for corporate travel?",
    answer: "Yes, our cab services are suitable for corporate meetings, employee transportation, client visits, and business travel."
  },
  {
    question: "How can I book Malad to Pune Cab with Trustline Travels?",
    answer: "Share your pickup location, Pune destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Sharma",
    feedback: "Trustline Travels provided an excellent Malad to Pune cab experience. The driver arrived on time, the car was clean, and the entire journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Poonam Joshi",
    feedback: "The service was reliable and professional. The booking process was easy, the driver was polite, and our journey from Malad to Pune was safe and enjoyable.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Malad to Pune Cab",
  "image": "https://www.trustlinetravels.com/assets/images/malad-to-pune-cab.webp",
  "description":
    "Book Malad to Pune Cab with Trustline Travels for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Malad to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, corporate travel, and outstation trips.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/malad-to-pune-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Malad to Pune Cab | One Way Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Malad to Pune Cab with Trustline Travels for reliable one-way and round-trip taxi services. Get affordable cabs from Malad to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta for outstation travel, airport transfers, and business trips available 24x7."
  />

  <meta
    name="keywords"
    content="Malad to Pune Cab, Malad to Pune Cab Service, Malad to Pune Taxi, Malad to Pune Taxi Service, Malad to Pune One Way Cab, Malad to Pune One Way Taxi, Malad to Pune Cab Booking, Malad to Pune Taxi Booking Online, Cab from Malad to Pune, Malad to Pune Car Rental, Cheap Cab Malad to Pune, Malad to Pune Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/4.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Maladtopunecab;